import React from "react";

import Card from "@material-ui/core/Card";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';

import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import MyLocationRoundedIcon from '@mui/icons-material/MyLocationRounded';
import LocationSearchingRoundedIcon from '@mui/icons-material/LocationSearchingRounded';
import GpsOffRoundedIcon from '@mui/icons-material/GpsOffRounded';
import Tooltip from '@mui/material/Tooltip';
import NewReleasesRoundedIcon from '@mui/icons-material/NewReleasesRounded';
import ReportRoundedIcon from '@mui/icons-material/ReportRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import Style from "../../../../styles/js/Styles";
import alerter from "../../../alerts/alerter";
import auth from "../../../../plas/auth/service";
import service from "../../../../plas/services/emergency/service"
import { states } from "../../../../plas/services/emergency/models"

function AlertItem({ data, onChange, onLocation }) {

  const style = Style();

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [updating, setUpdating] = React.useState(false);

  const ColoredLine = ({ color, marginBottom, margingTop}) => (
      <hr
          style={{
              color: color,
              backgroundColor: color,
              marginTop: margingTop !== undefined ? margingTop : 6,
              marginBottom: marginBottom !== undefined ? marginBottom : 6,
              height: 1
          }}
      />
  );

  const update = () => {
    let reply = {
      requestId: data.alert.id,
      userId: auth.getUser().id,
      code: data.alert.state + 1,
    };

    setUpdating(true);
    service.api.replies.create(data.alert.id, reply, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        data.alert.state = response.result.code;
        data.alert.lastUpdate = response.result.creationTime;
        onChange(data);
      }
      setUpdating(null);
    });
  }

  const getMobilityStatus = (mobility, showLocation) => {
    
    let color = "gray"
    let message = "Sin datos de localización recientes"

    if (mobility) {
      switch (mobility.state) {
        case states.mobilityState.OK:
          color = "green";
          break;
        case states.mobilityState.DELAYED:
          color = "gold";
          break;
        default: break;
      }

      if (mobility.state !== states.mobilityState.OLD) {
        let now = Date.now();
        let dataAge = now - mobility.time;

        if (dataAge < 60000)
          message = "Localizado hace menos de un minuto";
        else if (dataAge < 1200000) 
          message = `Localizado hace ${(dataAge/60000).toFixed(0)} minutos`
        else if (dataAge < 3600000)
          message = "Localizado hace menos de una hora"
        else
          message = `Localizado hace ${(dataAge/3600000).toFixed(0)} horas`
      }
    }

    let icon = (color === 'darkred' || color === 'gray') ? 
      (<GpsOffRoundedIcon fontSize='small' style={{color: color}}/>) : color === 'gold' ? 
      (<LocationSearchingRoundedIcon fontSize='small' style={{color: color}}/>) : 
      (<MyLocationRoundedIcon fontSize='small' style={{color: color}}/>);

    return (
      <span 
        className={(showLocation && mobility && mobility.location) ? style.selectable : null} 
        onClick={() => { 
          if (showLocation && mobility && mobility.location) 
            onLocation(mobility.location) 
        }}>
        <Tooltip title={<span style={{fontSize: 13}}>{message}</span>}> 
          {icon}
        </Tooltip>
      </span>
    )   
  }

  const getStatus = (data) => {
    let icon = null;
    let color = null;
    let title = null;

    switch (data.state) {
      case states.victimStates.DANGER: 
        color = '#F99B38';
        title = 'Perimetral violada'
        icon = (<ReportRoundedIcon fontSize="small"/>)
        break;
      case states.victimStates.WARN: 
        color = '#CEBF07';
        title = 'Advertencia de distancia'
        icon = (<ReportProblemRoundedIcon fontSize="small"/>)
        break;
      case states.victimStates.INFO: 
        color = '#38B9F9';
        title = 'Datos de localización desactualizados'
        icon = (<InfoRoundedIcon fontSize="small"/>)
        break;
      case states.victimStates.ALERT:
        color = '#F94638';
        switch (data.alert.state) {
          case 2: 
            title = 'Policía en camino'
            break;
          case 1: 
            title = 'Alerta recepcionada'
            break;
          default: 
            title = 'Botón de pánico activado'
             break;

        }
        icon = (<NewReleasesRoundedIcon fontSize="small"/>)        
        break; 
      default: // states.victimStates.OK
        color = '#6ED82E';
        title = 'Todo parece estar bien'
        icon = (<CheckCircleRoundedIcon fontSize="small" />)        
        break;
    }

    return (
      <Grid container spacing={1} style={{height: 42, color: 'white', textAlign: 'left', backgroundColor: color, padding: 4, paddingBottom: 2}}>
        <Grid item>
          <Box
            display="flex"
            alignItems="center"
            height="100%"> 
            { icon }
          </Box>
        </Grid>
        <Grid item xs={true} style={{fontSize: 15}}>
          <Box
            display="flex"
            alignItems="center"
            height="100%"> 
            <b>{ title }</b>
          </Box>
        </Grid>
        <Grid item>
          { data.alert && (
              <ThemeProvider theme={theme}>
                <LoadingButton
                  disabled={updating}
                  size="small"
                  loadingPosition="start"
                  startIcon={<DoneIcon />}
                  loading={updating}
                  variant="outlined"
                  onClick={update}>
                  <b>{ data.alert.state === 0 ? "Recepcionar" : data.alert.state === 1 ? "Policia en camino" : "Resolver" }</b>
                </LoadingButton>
              </ThemeProvider>
          )}
        </Grid>
      </Grid>
    )
  }

  const getProfileInfo = (profile, violent) => {
    return (
      <Grid container spacing={1} style={{padding: 4}}>
        <Grid item xs={12}>
          <span style={{fontSize: 15 }}>{`Nombre: ${profile.name} ${profile.lastName}`}</span>
        </Grid>
        { profile.phoneNumber && (
          <Grid item xs={12}>
            <span style={{fontSize: 15 }}>{`Tel: ${profile.phoneNumber}`}</span>
          </Grid>
        )}
        { violent && (
          <>
          <Grid item xs={12}>
            <ColoredLine />
          </Grid>
          <Grid item xs={12}>
            <span style={{fontSize: 15 }}>{`Denunciado: ${violent.name} ${violent.lastName}`}</span>
          </Grid>
          { violent.phoneNumber && (
            <Grid item xs={12}>
              <span style={{fontSize: 15 }}>{`Tel: ${violent.phoneNumber}`}</span>
            </Grid>
          )}
          </>
        )}
      </Grid>
    )
  }

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Card style={{ textAlign: 'left', marginBottom: 8 }}>
          {/* Barra de estado */}
          { getStatus(data) }
          
          {/* Encabezados */}
          <Grid container spacing={2} 
            style={{ paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8, fontSize: 14, color: 'gray'}}>
            <Grid item xs={true} style={{textAlign: 'left'}}>
              Victima
            </Grid>
            <Grid item style={{textAlign: 'center'}}>
              { data.restrictions.length > 0 ? 'Distancia' : '' }
            </Grid>
            <Grid item xs={true} style={{textAlign: 'right'}}>
              { data.restrictions.length === 0 ? '' : data.restrictions.length === 1 ? 'Victimario' : 'Victimarios' }
            </Grid>
          </Grid>

          <Grid container spacing={0} style={{paddingTop: 2, paddingBottom: 6, paddingLeft: 8, paddingRight: 8}}>
            {/* Datos de la victima */}
            <Grid item xs={true}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"> 
                <Grid container spacing={1}>
                  <Grid item>   
                   <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%">                  
                      { getMobilityStatus(data.mobility, data.isImportant()) }
                    </Box>
                  </Grid>
                  <Grid item xs={true}>
                    <Box
                    display="flex"
                    alignItems="center"
                    height="100%">   
                      <span
                        style={{fontSize: 15, textAlign: 'left', 'WebkitLineClamp': 1, paddingLeft: 2, paddingRight: 2}} 
                        className={style.ellipseableText}>
                        { data.profile ? `${data.profile.name} ${data.profile.lastName}`: "-" }
                      </span>
                      { data.profile && (
                        <Tooltip title={getProfileInfo(data.profile, data.accusedProfile)}>
                          <AssignmentIndIcon 
                            className={style.selectable} 
                            fontSize="small" 
                            style={{marginLeft: 4}}/>
                        </Tooltip>
                      )}
                    </Box>
                  </Grid>    
                </Grid>
              </Box>
            </Grid>

            {/* Distancias de perimetrales */}
            <Grid item style={{textAlign: 'center', paddingLeft: 8, paddingRight: 8}}>
              <Grid container spacing={1}>
                { data.restrictions.map((perimetral) => (
                  <Grid key={perimetral.id} item xs={12}>
                    <span>↤ </span>
                    <span style={{fontSize: 15}}>{ perimetral.distanceAsText() }</span>
                    <span> ↦</span>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Datos de la acusados */}
            <Grid item xs={true}>
              <Grid container spacing={1}>
                { data.restrictions.map((perimetral) => (
                  <Grid item xs={12} key={perimetral.id}>
                    <Grid container spacing={1}>
                      <Grid item xs={true}>
                        <Box
                        display="flex"
                        justifyContent="right"
                        alignItems="center"
                        height="100%">
                          { perimetral.profile && (
                            <Tooltip title={getProfileInfo(perimetral.profile)}>
                              <AssignmentIndIcon 
                                className={style.selectable} 
                                fontSize="small" 
                                style={{marginRight: 4}}/>
                            </Tooltip>
                          )}
                          <span
                          style={{fontSize: 15, textAlign: 'right', 'WebkitLineClamp': 1, paddingLeft: 2, paddingRight: 2}} 
                          className={style.ellipseableText}>
                            { perimetral.profile ? `${perimetral.profile.name} ${perimetral.profile.lastName}`: "-" }
                          </span>
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="100%">                  
                          { getMobilityStatus(perimetral.mobility, data.isImportant()) }
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>

          </Grid>
        </Card>
      </Grid>

    </Grid>
  );

}

export default AlertItem;

